<template>
    <div id="datatable-entities-backoffice">
        <v-data-table
            :headers="headers"
            :items="listEntities"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 20, 50]
            }"
            dense
        >
            <template v-slot:[`item.promoEngineGroupsCount`]="{ item }">
                <span>{{ item.promoEngineGroupsCount }}</span>
                <v-tooltip color="transparent" bottom>
                    <template v-slot:activator="{ on }">
                        <span class="mr-2 p-0 cog" v-on="on">
                            <v-icon>mdi-information</v-icon>
                        </span>
                    </template>
                    <v-data-table
                        v-if="item.promoEngineGroupsCount > 0"
                        style="box-shadow: 0 0 2px 1px grey"
                        :headers="headersTooltip"
                        :items="[{ groups: item.groupList }]"
                        hide-default-footer
                    ></v-data-table>
                </v-tooltip>
            </template>
            <template v-slot:[`item.promoEngineReceiverTypeId`]="{ item }">
                <v-select
                    :items="
                        receiverTypes.map((el) => ({
                            text: el.name,
                            value: +el.value,
                        }))
                    "
                    v-model="item.promoEngineReceiverTypeId"
                    :menu-props="{ top: false, offsetY: true }"
                >
                </v-select>
            </template>
            <template v-slot:[`item.entityStatusID`]="{ item }">
                <v-chip
                    :color="getColor(item.entityStatusID)"
                    pill
                    dark
                    style="width: 80%"
                    class="status-column justify-content-center"
                >
                    {{ getStatusDescription(item.entityStatusID) }}
                </v-chip>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        listEntities: Array | Object,
        totalItems: Number | String,
        receiverTypes: Array | Object,
    },
    data() {
        return {
            headersTooltip: [
                {
                    text: this.$t(
                        "backoffice.modules.promo-engine.associated-groups"
                    ),
                    align: "start",
                    filterable: false,
                    value: "groups",
                },
            ],
            headers: [
                {
                    text: this.$t("backoffice.modules.promo-engine.number"),
                    align: "start",
                    value: "entityId",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.company"),
                    align: "start",
                    value: "name",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.email"),
                    align: "start",
                    value: "email",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t(
                        "backoffice.modules.promo-engine.receiver-type"
                    ),
                    align: "start",
                    value: "promoEngineReceiverTypeId",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t(
                        "backoffice.modules.promo-engine.associated-groups"
                    ),
                    align: "start",
                    value: "promoEngineGroupsCount",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.status"),
                    align: "center",
                    value: "entityStatusID",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
            ],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
        };
    },
    watch: {
        "options.page": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
    },
    methods: {
        getColor(status) {
            switch (status) {
                case this.$globals.ENTITY_STATUS.ACTIVE:
                    return "green";
                case this.$globals.ENTITY_STATUS.INACTIVE:
                    return "red";
                case this.$globals.ENTITY_STATUS.FILED:
                    return "orange";
                default:
            }
        },
        getStatusDescription(status) {
            switch (status) {
                case this.$globals.ENTITY_STATUS.ACTIVE:
                    return this.$t("backoffice.general.active-status");
                case this.$globals.ENTITY_STATUS.FILED:
                    return this.$t("backoffice.general.filed-status");
                case this.$globals.ENTITY_STATUS.INACTIVE:
                default:
                    return this.$t("backoffice.general.inactive-status");
            }
        },
        getTooltipItems(groupList) {
            return [{ groups: groupList }];
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-entities-backoffice {
    tr {
        height: 42px;
    }
}
</style>
